import FlexBox from "./account/components/FlexBox";

import { ErrorOutlineOutlined } from "@mui/icons-material";
import { Typography, Box } from "@mui/material";
import { LiLink, AppWrap } from "../common/commonComps";
import type { FallbackProps } from "react-error-boundary";

const ErrorPage = ({ resetErrorBoundary }: FallbackProps) => {
    const goTo = (v: string) => {
        resetErrorBoundary();
        window.location.href = v;
    };
    return (
        <AppWrap>
            <FlexBox sx={{ padding: `30px`, flexDirection: `column` }}>
                <ErrorOutlineOutlined sx={{ fontSize: 80, color: `error.main`, mb: 2 }} />
                <Typography variant="h4" gutterBottom>
                    Oops! Something went wrong.
                </Typography>
                <Typography variant="body1" color="text.secondary" mb={3}>
                    Don&apos;t worry, we&apos;ll have it fixed soon!
                </Typography>
                <Box>
                    <LiLink to="" onClick={() => goTo(`/`)}>
                        Click Here To Go Back Home.
                    </LiLink>
                </Box>
            </FlexBox>
        </AppWrap>
    );
};

export default ErrorPage;
